import React, { useState, useEffect } from "react";
import Table from "../../../../common/table/Table.component";
import SideModal from "../../../../common/modal/SideModal.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { regular, solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import CreateLegalMatter from "../../../components/legal-matter-component/CreateLegalMatter.component";
import LegalMatterClient from "../../../api-services/coders/legal-matter/legal-matter-client";
import HandlingResponse from "../../../../common/handling-response/handlingResponse";
import ButtonWithComfirmation from "../../../../common/button-with-confirmation/ButtonWithConfirmation.component";

const LegalMatter = () => {
  const tableName = "SP_LEGAL_MATTER";
  
  const columns = [
    {
      Header: "Назив правне материје",
      accessor: "name",
      disableFilters: false,
    },
    {
      Header: "Тежина",
      accessor: "weight",
    },
    {
      Header: "Активан",
      accessor: "isActive",
      Cell: ({ row }) => {
          return row.original.isActive && <FontAwesomeIcon icon={solid("check")} />;
      },
    },
    {
      accessor: "edit",
      disableSortBy: true,
      className: "two-buttons-column",
      Cell: ({ row }) => {
        return (
          <>
            <button
              className="btn btn-primary table-btn"
              onClick={() => onEditClick(row.original)}
              type="button"
            >
              <FontAwesomeIcon icon={solid("pencil")} />
            </button>
            <ButtonWithComfirmation 
            className="btn btn-danger table-btn" 
            onClick={() => onDeleteClick(row.original.id)}
            contentText={"Правна материја ће бити трајно обрисана."}
            handleYesText={"Обриши"}
            >
              <FontAwesomeIcon icon={solid("times")} />
            </ButtonWithComfirmation>
          </>
        );
      },
    },
  ];
  
  const [legalMatter, setLegalMatter] = useState([]);
  const [isCreate, setIsCreate] = useState(true);
  const [show, setShow] = useState(false);
  const [rowData, setRowData] = useState({
    id: "",
    name: "",
    weight: 0,
    lastModifyDate: "",
    userGuid: "",
    isActive: true,
  });

  const client = new LegalMatterClient();
  
  useEffect(() => {
    LegalMatter();
  }, []);

  const showModal = () => setShow(true);
  const hideModal = () => {
    setShow(false);
    setRowData({
      id: 0,
      name: "",
      weight: 0,
      lastModifyDate: "",
      userGuid: "",
      isActive: true,
    });
  }

  const onCreateClick = () => {
    setIsCreate(true);
    setRowData({
      id: 0,
      name: "",
      weight: 0,
      lastModifyDate: "",
      userGuid: "",
      isActive: true,
    });
    showModal();
  };

  const onEditClick = (row) => {
    setIsCreate(false);
    setRowData(row);
    showModal();
  };

  const onDeleteClick = async (id) => {
    var response = await client.DeleteLegalMatter(id);
    var handledResponse = HandlingResponse(response);
    if(handledResponse !== 'Error') {
      let legalMatterCopy = legalMatter.filter((x) => x.id !== id);
      setLegalMatter(legalMatterCopy);
    }
  };

  const LegalMatter = async () => {
    await client.LegalMatter().then((response) => {
      var handledResponse = HandlingResponse(response);
      handledResponse !== 'Error' && setLegalMatter(handledResponse);
    });
  }

  return (
    <>
      <h4>Правна материја</h4>
      <div className="text-right">
        <button
          onClick={onCreateClick}
          type="button"
          className="btn btn-primary"
        >
          Додај нову правну материју
        </button>
      </div>
      <Table
        columns={columns}
        data={legalMatter}
        tableName={tableName}
        rememberFilter={true}
        serverSide={false}
      />
      <SideModal
        show={show}
        handleClose={hideModal}
        title={
          isCreate ? "Креирање нове правне материје" : "Измена правне материје"
        }
      >
        <CreateLegalMatter
          row={rowData}
          isCreate={isCreate}
          handleCallback={() => {
            hideModal();
            LegalMatter();
          }}
        />
      </SideModal>
    </>
  );
};

export default LegalMatter;
